import { Component, OnDestroy, OnInit, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { navItems } from '../../_nav';
import { version } from '../../../../package.json';
import { PenggunaInfoService } from '../../_services/pengguna-info.service';
import { PenggunaInfoModel } from '../../_model/pengguna-info.model';
import { AuthenticationService } from '../../_services/auth/authentication.service';
import { ActivatedRoute, NavigationEnd, PRIMARY_OUTLET, Router } from '@angular/router';

import { filter } from 'rxjs/operators';
import { map } from 'rxjs/internal/operators';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html'
})
export class DefaultLayoutComponent implements OnInit, OnDestroy {

  listAplikasi: any = [];
  listSekolah: any = [];
  listPengguna: any = [];
  tahunAnggaran: string;
  public navItems = navItems;
  public sidebarMinimized = true;
  private changes: MutationObserver;
  public element: HTMLElement;

  public breadcrumbs;
  public title: string
  role: string;
  currentUser: any;

  constructor(
    private _auth: AuthenticationService,
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
    private _penggunaInfo: PenggunaInfoService,
    @Inject(DOCUMENT) _document?: any
  ) {

    this.changes = new MutationObserver((mutations) => {
      this.sidebarMinimized = _document.body.classList.contains('sidebar-minimized');
    });
    this.element = _document.body;
    this.changes.observe(<Element>this.element, {
      attributes: true,
      attributeFilter: ['class']
    });

    this._router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .pipe(map(() => this._activatedRoute))
      .pipe(map((route) => {
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      }))
      .pipe(filter(route => route.outlet === PRIMARY_OUTLET))
      .subscribe(route => {
        let snapshot = this._router.routerState.snapshot;
        let title = route.snapshot.data['title'];
        let parent = route.parent.snapshot.data['breadcrumb'];
        let parentPath = route.parent.snapshot.data['path'];
        let child = route.snapshot.data['breadcrumb'];
        let childPath = route.snapshot.data['path'];
        this.breadcrumbs = {};
        this.title = title;

        this.breadcrumbs = {
          "parentBreadcrumb": parent,
          "parentPath": parentPath,
          "childBreadcrumb": child,
          "childPath": childPath
        }
        console.log(this.breadcrumbs);
      });
  }

  ngOnInit(): void {
    const data = JSON.parse(localStorage.getItem('tahunAnggaran'));
    this.tahunAnggaran = data;
    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    this.role = this.currentUser.authorities[0];
    console.log('currentUser:', this.currentUser.authorities[0]);

    this.getMenu();
    this.getSekolah();
    this.getPengguna();
  }

  ngOnDestroy(): void {
    this.changes.disconnect();
  }


  getSekolah() {
    this._penggunaInfo.listSekolah().subscribe((response) => {
      console.log(response.body, 'Check Sekolah');
      if (response.status === 200) {
        this.listSekolah = response.body;
      }
    });
  }
  getPengguna() {
    this._penggunaInfo.findInfo().subscribe((response) => {
      console.log(response.body, 'Check Sekolah');
      if (response.status === 200) {
        this.listPengguna = response.body;
      }
    });
  }

  getMenu() {
    this._penggunaInfo.listOtoritas().subscribe((response) => {
      if (response.status === 200) {
        this._penggunaInfo.listAplikasiWithMenu().subscribe(response2 => {
          if (response.status === 200) {
            this.listAplikasi = response2.body;
            console.log("list Aplikasi with Menu" + this.listAplikasi)
            var user = JSON.parse(localStorage.getItem("currentUser"));

            for (let i = 0; i < this.listAplikasi.length; i++) {
              if (this.listAplikasi[i].kode == 'BOP') {
                for (let j = 0; j < this.listAplikasi[i].menu.length; j++) {
                  if (this.listAplikasi[i].menu[j].link == 'persetujuan-npd' && user.authorities[0] == 'SUDIN') {
                    this.listAplikasi[i].menu[j].link = 'persetujuan-npd-sudin-bop';
                  }
                }
              }
            }
          }
        }, error => {
        }
        );
      }
    }
    );
  }

  click() {
    if (this._auth.isAuthenticated()) {
      localStorage.removeItem('currentUser');
      // location.reload();
      this._router.navigate(['/landingpage']);
      window.localStorage.clear();
    } else {
      this._router.navigate(['/login']);
    }
  }
}
